export default __webpack_public_path__ + "static/media/ielts-7-thumb.3e03f93e.jpg";